export default {
  // the app loader on the first load (#223)
  app_loader: {
    title: 'Getting GreenMapper ready',
    steps: {
      connect: 'Connecting to GreenMapper',
      account: 'Fetching your account',
      places: 'Putting the areas on the map',
      communities: 'Loading the communities',
      news: 'News and settings',
      settings: 'Getting everything ready',
      ready: 'Ready!'
    },
    slow: 'This is taking longer than usual.',
    retry: 'Try again',
    open_anyway: 'Open anyway'
  },
  // a login link from an e-mail and an unknown address (#340: on the app loader's card)
  redirect: {
    failed: 'This login link no longer works',
    title: 'Logging you in…',
    step: 'Logging in'
  },
  not_found: {
    checking: 'Checking whether the page exists…',
    checking_sub: 'Looking for the page',
    title: '404: page not found',
    text: 'There is nothing at this address.',
    home: 'Back to the home page'
  },
  notice: {
    progress: '{done} of {total} places marked',
    places_left: '1 more place to mark | {left} more places to mark',
    participation_hint: 'A few steps left to complete your places.',
    participation_unfinished: 'Your participation is not finished yet'
  },
  home_tiles: {
    areas_count: '{count} area | {count} areas',
    communities_count: '{count} community | {count} communities',
    budget_line: '{amount} budget · {pct}% pledged',
    subscribers: '{count} subscriber | {count} subscribers',
    notifications: 'Notifications',
    unread: '{count} unread',
    all_read: 'All caught up',
    no_messages: 'No messages yet',
    pledged: 'pledged',
    no_budget: 'No nature budget yet',
    no_areas: 'No areas yet. Mark places you care about on the map.',
    no_communities: 'Not subscribed to a community yet.',
    browse_map: 'Browse map',
    greet_morning: 'Good morning, {name}',
    greet_afternoon: 'Good afternoon, {name}',
    greet_evening: 'Good evening, {name}',
    per_year: 'a year',
    new: 'new'
  },
  // the create-community wizard's texts (#126)
  wizard_versions: {
    // #321: the find screen's list / map switch (phones) and the larger map (wider screens)
    search_short: 'Search',
    view_list: 'List',
    view_map: 'Map',
    map_larger: 'Larger map',
    map_smaller: 'Show the list again',
    cancel: 'Cancel',
    question: 'Which area do you manage?',
    results: 'Results',
    legend: 'Filters',
    filters_open: 'Open the filters',
    filters_collapse: 'Collapse the filters',
    new_community: 'New community',
    back_to_results: 'Back to the list',
    col_name: 'Name',
    my_location: 'My location',
    locate: 'Areas near my location',
    locate_failed: 'Your location could not be found. Search for a place.',
    locate_denied: 'You did not share your location. Allow it in the browser, or search for a place.',
    locate_insecure: 'Your location only works over a secure connection (https). Search for a place.',
    loading_results: 'Loading areas…',
    lists_n: '{count} lists',
    col_type: 'Kind',
    col_country: 'Country',
    col_size: 'Area',
    position: 'Position',
    loading_title: 'Getting the map ready',
    load_lists: 'The lists',
    load_areas: 'The first areas',
    load_map: '{list} on the map',
    load_index: 'Building the map',
    areas_here: '{count} areas here',
    choose_area_here: 'Choose one of the {count} areas here',
    map_updating: 'Updating the map…',
    map_areas_loading: 'Loading the areas…',
    map_loading: 'The map is still loading every area…',
    sheet: 'Make the list bigger or smaller',
    count_areas: 'no areas | 1 area | {count} areas',
    // waits (the user, 11 Oct): a long one, no connection, a failure; "Try again" asks the same again
    slow: 'This is taking longer than usual.',
    try_again: 'Try again',
    offline: 'No connection to the server. Reconnecting…',
    reconnect: 'Try now',
    lists_failed: 'The lists could not be loaded.',
    places_failed: 'Places could not be searched.',
    sending: 'Submitting your community…',
    count_failed: 'The fans could not be counted.'
  },
  messages: {
    pictures_missing: 'A picture of this post could not be loaded: it is left out when you save.',
    // account_created: 'Please check your email to verify your registration. This sometimes can take up to 10 minutes. Please check the spam folder if the email has not been received.',
    // password_forgot: 'Please check your email to reset your password.',
    // verification_success: 'Your e-mail has been verified. You can now login.',
    // verification_failed: 'Verification has failed.',
    // password_recover_success: 'Your password has been reset. You can now login with the new password.',
    // logout_confirmation: 'Are you sure you want to log out?',
    // confirm: 'Confirm',
    // update_available: 'A new update is available. Click on ok to reload the page.',
    // account_signed_out: 'You have been signed out',
    // account_updated: 'Account succesfully updated'
    account_created: 'Account successfully created',
    password_forgot: 'Please check your email to reset your password.',
    account_signed_out: 'You have been signed out',
    logout_failed: 'You could not be logged out. Please try again.',
    account_updated: 'Account succesfully updated',
    verification_success: 'Your e-mail has been verified. You can now login.',
    verification_failed: 'Verification has failed.',
    password_recover_success: 'Your password has been reset. You can now login with the new password.',
    password_reset_link_invalid: 'This link does not work any more. A reset link works once, for 24 hours. Ask for a new one with \'Forgot password?\' on the login screen.',
    password_reset_failed: 'Your password could not be changed. Please try again.',
    password_reset_to_login: 'To the login screen',
    logout_confirmation: 'Are you sure you want to log out?',
    login_confirmation: 'You have succesfully signed in. Welcome back!',
    login_failed: 'Email and password combination not recognised',
    confirm: 'Confirm',
    update_available: 'A new update is available. Click on ok to reload the page.',
    update_ready: 'A new version of the app is ready.',
    update_reload: 'Reload',
    url_copied_to_clipboard: 'The map url has been copied to clipboard',
    add_area_account_required: 'To add a new area you\'re required to have an account.',
    area_deleted: 'Area has been removed',
    area_updated: 'Area has been updated',
    unsubscribed: 'You have been unsubcribed from the community',
    subscribed: 'You are now part of this community',
    thread_created: 'A new thread has been created',
    thread_updated: 'Discussion has been updated',
    comment_created: 'You have posted a reply',
    comment_reported: 'This content has been flagged for moderation',
    comment_unreported: 'This content has been cleared by moderation',
    comment_deleted: 'This content has been deleted',
    community_updated: 'This community has been updated',
    RMS_send: 'Moderator request has been sent',
    poll_created: 'Poll created',
    polis_created: 'Polis created',
    meeting_created: 'Meeting created',
    meeting_invite_accepted: 'You have accepted the invite',
    meeting_invite_declined: 'You have declined the invite',
    pledge_funding_completed: 'Virtual pledge funding succesfully completed',
    pledge_added: 'Thank you for your pledge of € ',
    pledge_rejected: 'Thank you for your elaboration',
    pledge_created: 'Pledge successfully created',
    pledge_updated: 'Pledge successfully updated',
    pledge_deleted: 'The pledge has been deleted',
    pledge_pictures_missing: 'A picture of this pledge could not be loaded: it is left out when you save.',
    treasure_created: 'Treasure successfully created'
  },
  errors: {
    general_error: 'An error occured. Please try again.',
    not_found: 'Sorry, nothing here...',
    network: 'Network error. Please check your internet connection',
    // fields: 'Please correct the input fields',
    required: 'Required field',
    register: {
      password_length: 'The minimum length of the password is {length} characters.',
      password_match: 'Passwords do not match.',
      email_valid: 'A valid email address is required',
      name_length: 'Display name length between {minLength} and {maxLength} characters ',
      organization_length: 'Organization name length between {minLength} and {maxLength} characters '
    }
  },
  buttons: {
    fullscreen: 'Full screen',
    fullscreen_exit: 'Leave full screen',
    pledge: 'Pledge',
    ok: 'Ok',
    submit: 'Submit',
    logout: 'Logout',
    cancel: 'Cancel',
    login: 'Login',
    register: 'Submit',
    // go_back: 'Go back',
    send: 'Send',
    reSend: 'Resend',
    close: 'Close',
    previous: 'Previous',
    save: 'Save',
    create: 'Create',
    update: 'Update',
    delete: 'Remove',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    next: 'Next',
    continue: 'Continue',
    back: 'Back',
    add: 'Add',
    edit: 'Edit',
    reply: 'Reply',
    report: 'Report',
    unreport: 'Unreport',
    goto_authenticate: 'To sign in',
    stop: 'Stop',
    pauze: 'Pauze',
    continue_register: 'Continue registration',
    continue_participation: 'Continue participation',
    mark_places: 'Mark places',
    become_moderator: 'Become moderator',
    add_image: 'Add image',
    accept: 'Accept',
    decline: 'Decline',
    reset: 'Reset',
    discard: 'Discard'
  },
  headers: {
    area_owners: 'Area owners',
    admin_home: 'Home',
    fans: 'Fans',
    maintenance: 'Maintenance',
    login: 'Login',
    register: 'Register',
    password_forgot: 'Request a new password',
    password_recover: 'Reset password',
    administrator: 'Administrator',
    navigation: 'Navigation',
    my_overview: 'My overview',
    overview: 'Overview',
    users: 'Users',
    communities: 'Communities'
  },
  activities: {
    act_cycl: {
      title: 'Cycling'
    },
    act_walk: {
      title: 'Walking or running'
    },
    act_tour: {
      title: 'Touring by car or motor'
    },
    act_natu: {
      title: 'Watching nature'
    },
    act_water: {
      title: 'Water sports'
    },
    act_play: {
      title: 'Playing or sitting'
    },
    act_wintr: {
      title: 'Winter sports'
    },
    act_mount: {
      title: 'Mountain sports'
    }
  },
  labels: {
    upvote: 'Agree',
    // a post's reply started from a comment (#340): the bar above the reply
    replying_to: 'Reply to',
    replying_to_cancel: 'Not as a reply to {name}',
    // the photo picker (UiPhotoPicker, #469)
    photo_add: 'Add a photo',
    photos_add: 'Add photos',
    photos_add_short: 'Add',
    photos_drop: 'tap, or drop them here (.jpg)',
    photos_jpg_only: 'Only .jpg photos can be added.',
    downvote: 'Disagree',
    // a wizard's step (UiWizard, #355)
    step_of: 'Step {step} of {total}',
    rows_of: '{shown} of {total}',
    show_more: 'Show {n} more',
    account_required: 'Account required',
    read_more: 'read more',
    'area_create_button': 'Save',
    'area_update_button': 'Save',
    'area_created_succes': 'Area is succesfully created',
    'area_updated_succes': 'Area is succesfully updated',
    'community_created_succes': 'Community is succesfully created',
    agree_disclaimer: 'I agree with these terms',
    my_account: 'My account',
    register: 'Create account',
    logout: 'Sign out',
    login: 'Sign in',
    email: 'Email address',
    name: 'Display name',
    companyName: 'Company name',
    organization: 'Organization name',
    sector: 'Sector',
    address: 'Address',
    address_search: 'Home',
    // zipcodeCompany: 'Zipcode headquarter',
    website: 'Webpage',
    city: 'City',
    // cityCompany: 'City headquarter',
    age: 'Age group',
    education: 'Education',
    gender: 'Gender',
    type: 'Type',
    password: 'Password',
    repeat_password: 'Repeat password',
    remember_me: 'Remember me',
    show_password: 'Show password',
    hide_password: 'Hide password',
    clear_address: 'Choose another address',
    password_forgot: 'Forgot your password?',
    home: 'Home',
    here: 'here',
    neighbourhood: 'neighbourhood',
    'living-area': 'region',
    country: 'country',
    worldwide: 'worldwide',
    share_this_area: 'Share this area',
    share_this_community: 'Share this community',
    subscribed: 'Subscribed',
    reply: 'Reply',
    comment: 'Comment',
    finish: 'Finish',
    readmore: 'read more',
    search: 'search',
    created_on: 'created_on',
    dear: 'Dear',
    karma: 'Karma'
  },
  pages: {
    free_draw: {
      title: 'Draw your area',
      tools: 'Drawing tools',
      mode_edit: 'Edit points',
      mode_move: 'Move shape',
      mode_rotate: 'Rotate shape',
      undo: 'Undo',
      more_tools: 'More tools',
      redo: 'Redo',
      delete_points: 'Delete points',
      import: 'Import a file (GeoJSON or KML)',
      start_over: 'Start over',
      start_over_title: 'Start over?',
      start_over_text: 'This removes the shape. You can still undo it.',
      layer_map: 'Map',
      layer_satellite: 'Satellite',
      my_location: 'My location',
      zoom_to_shape: 'Zoom to shape',
      search_place: 'Search a place',
      search_place_placeholder: 'Place, then Enter',
      warn_point_outside: 'Your drawing does not contain the location of {name}.',
      warn_size: 'Your drawing ({drawn}) is very different from the reported size ({reported}).',
      warn_huge: 'Your area is very large: {size}. Is that right?',
      more: 'More',
      hint_closed_phone: 'Shape closed. Drag a point to adjust the boundary; hold a point to remove it.',
      hint_many_phone: 'A shape with {count} points: they are shown spread out. Zoom in for more points to drag.',
      legend_title: 'Also useful',
      legend_last: 'Click the last point to remove it',
      legend_undo: 'Ctrl+Z undoes, Ctrl+Y redoes',
      legend_import: 'Importing a boundary works too (GeoJSON or KML)',
      reported: 'Reported: {size}',
      your_drawing: 'your drawing: {size}',
      area: 'Area',
      border: 'Border',
      close_shape: 'Close shape',
      close_shape_tip: 'Or click the first point, or press Esc',
      points_count: 'no points | 1 point | {count} points',
      hint_tap: 'Click on the map to place points along the border. Click the first point to close the shape.',
      hint_edit: 'Drag a point to move it. Drag a small dot on a line to add a point. Right-click a point to remove it.',
      hint_edit_many: 'This shape has many points: they are shown spread out, more as you zoom in. Drag a point to move it. Drag a small dot on a line to add a point. Right-click a point to remove it.',
      hint_delete: 'Tap a point to remove it. Tap the delete tool again to stop.',
      hint_delete_click: 'Click a point to remove it. Click the delete tool again to stop.',
      hint_move: 'Drag the shape to move it.',
      hint_rotate: 'Drag a corner handle to rotate the shape.',
      check_points: 'Closed shape with at least {min} points',
      check_crossing: 'No crossing lines',
      check_range: 'Not across the date line (180°)',
      check_area_min: 'At least {minArea}',
      check_area_max: 'At most {maxArea}',
      check_points_max: 'At most {max} points',
      problem_points: 'Close the shape with at least {min} points.',
      problem_crossing: 'Lines cross each other. Move a point so they no longer cross.',
      problem_range: 'The shape crosses the date line (180°). Draw it on one side of that line.',
      problem_area_min: 'The area is too small: it must be at least {minArea}.',
      problem_area_max: 'The area is too large: it can be at most {maxArea}.',
      problem_points_max: 'The shape has too many points: at most {max}.',
      rejected_cross: 'Lines may not cross',
      rejected_min_points: 'At least {min} points',
      location_unavailable: 'Your location is not available.',
      imported: 'Imported a shape with {count} points. Check it and adjust where needed.',
      import_errors: {
        unknown_format: 'This file is not GeoJSON or KML.',
        no_polygon: 'The file contains no area (polygon).',
        multiple: 'The file contains more than one area. Use a file with one area.',
        holes: 'The area has holes. Use an area without holes.',
        invalid: 'The area in this file is not valid.'
      }
    },
    owner_community_new: {
      // #197: the boundary lies on (almost) the same area as an existing community
      overlap: {
        warning: 'There is already a community on (almost) the same area: {title}. You can still create one.',
        // another owner's community before its first approval: its name is not shown (#96)
        unnamed: 'a community waiting for approval'
      },
      // #198: after drawing, the list area the drawing matches
      suggest: {
        title_used: 'Your area',
        locked_size: 'Official boundary · {size}',
        locked_hint: 'You use the official boundary. Draw it yourself? Choose Undo.',
        checking: 'Checking…',
        choose_first: 'Choose first: the official boundary or your own drawing',
        question: 'Is this the area you mean?',
        previous: 'Previous',
        next: 'Next',
        count: '{at} of {of}',
        use_official: 'Use the official boundary',
        link: 'Link my drawing',
        keep: 'Keep my drawing',
        link_note: 'This area has no boundary in the list: your drawing becomes its boundary, the name and details come from the list. Other owners can then no longer choose it.',
        used: 'Official boundary of {name} used',
        linked: 'Your drawing is linked to {name}',
        kept: 'You keep your own drawing',
        undo: 'Undo',
        show_again: 'Show again'
      },
      title_draw: 'Draw your area',
      title_draw_boundary: 'Draw the boundary',
      title_details: 'Name your community',
      title_fans: 'Who counts as a fan',
      title_fans_named: 'Who becomes a fan of {name}?',
      drawn_tag: 'Drawn yourself',
      continue_short: 'Continue',
      continue: 'Continue to name and description',
      continue_fans: 'Continue to who counts as a fan',
      name: 'Community name',
      name_required: 'Give your community a name.',
      description: 'Description',
      description_hint: 'What is this area and what is the community about?',
      description_required: 'Describe the area and the community.',
      submitted: '{name} is submitted for review',
      // the last step: the community as its page will show it (#96)
      review: {
        fans_count: '{n} fan | {n} fans',
        fans_few: 'fewer than {n} fans',
        more: 'more',
        submit: 'Submit for review',
        confirm_title: 'Submit your community?',
        confirm_text: 'Greenmapper checks {name} first. Once approved, your community gets {fans}. You can still change its name and description afterwards.',
        confirm_plain: 'Greenmapper checks your community first. You can still change its name and description afterwards.',
        confirm_back: 'Keep looking',
        confirm_submit: 'Submit'
      },
      steps: {
        area: 'Area',
        fans: 'Fans',
        name: 'Name'
      },
      exit: 'Stop',
      exit_title: 'Stop creating this community?',
      exit_text: 'What you chose, drew or typed is not saved.',
      exit_keep: 'Continue',
      exit_confirm: 'Stop',
      back: 'Back',
      method: {
        free_title: 'Draw it yourself',
        free_text: 'Draw the boundary of your area on the map, or import a GeoJSON or KML file.'
      },
      find: {
        clear_filters: 'Clear filters',
        without_list: 'Without {list}',
        with_list: 'With {list}',
        filters: 'Filters',
        clear_all: 'Clear all',
        close: 'Close',
        lists_title: 'Lists',
        size: 'Size',
        size_any: 'Any size',
        size_up_to: 'Up to {max} ha',
        size_from: 'From {min} ha',
        size_between: '{min}–{max} ha',
        place_title: 'Place',
        clear_place: 'Remove the place',
        place_remove: 'Remove',
        countries_all: 'Show all {count} countries',
        countries_less: 'Fewer countries',
        show_n: 'Show 1 area | Show {count} areas',
        places_none_in: 'No place “{query}” in {country}',
        around_chip: 'Around {place}',
        none_near_named: 'No area with “{query}” near {place}.',
        radius: 'Radius',
        radius_caption: 'Within a distance of',
        other_places: 'Other places with this name',
        near_action: 'Areas nearby',
        show_all: 'Show the area with “{query}” | Show all {count} areas with “{query}”',
        country_search: 'Search a country',
        country_any: 'All countries',
        country_none: 'No country found',
        none_named: 'No area named “{query}”',
        show_all_more: 'Show all areas with “{query}” ({count}+)',
        places_none: 'No place found',
        places_searching: 'Searching places…',
        places_failed: 'Searching places does not work right now',
        availability: 'Availability',
        count_more_short: '{count}+',
        refine: 'Refine your search to see the rest.',
        near_title: 'Areas around {place} (within {km} km)',
        places_group: 'Places',
        areas_group: 'Areas',
        place_kinds: {
          city: 'City',
          town: 'Town',
          village: 'Village',
          hamlet: 'Hamlet',
          suburb: 'District',
          municipality: 'Municipality',
          county: 'Region',
          state: 'Province',
          country: 'Country',
          island: 'Island',
          nature_reserve: 'Nature reserve',
          national_park: 'National park',
          protected_area: 'Protected area',
          lake: 'Lake',
          peak: 'Peak',
          forest: 'Forest',
          wood: 'Wood',
          heath: 'Heath',
          moor: 'Moor',
          wetland: 'Wetland'
        },
        title: 'Find your area',
        search: 'Search an area or a place',
        country: 'Country',
        all: 'All',
        available: 'Available',
        taken: 'Taken',
        count: 'no areas | 1 area | {count} areas',
        failed: 'Searching failed.',
        place_failed: 'The place search does not answer right now. Searching by name still works.',
        no_places: 'No place found for “{query}”.',
        none_near: 'No listed areas near {place}.',
        none_filters: 'No areas match these filters.',
        none_taken: 'No areas in use.',
        badge_official: 'Official',
        badge_partial: 'Core area',
        badge_proxy: 'Approximate',
        badge_draw: 'Draw it',
        // #196: the other lists the same area is in (one row per area group)
        also_in: 'Also in {lists}',
        badge_in_use: 'In use',
        badge_disabled: 'Unavailable',
        sources_short: {
          unesco: 'UNESCO',
          eea: 'EEA',
          wdpa: 'WDPA',
          osm: 'OSM',
          research: 'Research',
          national: 'National',
          arcgis: 'Map layer',
          province: 'Province',
          other: 'Other source'
        },
        osm_credit: '© OpenStreetMap contributors'
      },
      // who counts as a fan (#96)
      fans: {
        what: 'Anyone who marked a place in your fan zone on Greenmapper becomes a fan and gets your messages.',
        what_close: 'Close explanation',
        what_open: 'What is a fan?',
        slider: 'Size of the fan zone',
        area_only: 'Only your area',
        area_only_short: 'Area only',
        recommended: 'Recommended',
        wide: 'Wide',
        back_to_recommended: 'Back to recommended',
        fans_short: 'fans in the zone',
        legend_area: 'Your area',
        legend_zone: 'Fan zone',
        // what each line on the map is for: the same words under the legend on every step and screen width
        legend_area_explain: 'Shown as your community',
        legend_zone_explain: 'Decides who becomes a fan',
        legend_start: 'Recommended',
        zone_is_area: 'same as your area',
        load_failed: 'The fan zone could not be loaded.',
        retry: 'Try again',
        failed: 'This position could not be calculated. Choose another position.',
        invalid: 'The fan zone was not accepted. Choose another position and try again.'
      },
      official: {
        not_listed_title: 'Is your area not in the list?',
        not_listed_text: 'Then draw its boundary yourself on the map.',
        choose_this: 'Choose this area',
        title: 'Your area',
        retry: 'Try again',
        no_results: 'No area found for “{query}”.',
        badge_official: 'Official boundary',
        badge_partial: 'Core area only',
        badge_proxy: 'Approximate area',
        badge_draw: 'No boundary: you draw it',
        reason_in_use: 'Already in use',
        in_use_by: 'Already in use by {title}',
        reason_disabled: 'Not available',
        boundary_from: 'Boundary: {source}.',
        boundary_drawn: 'Boundary drawn by you',
        source_link_short: 'Open page',
        fact_type: 'Type',
        fact_country: 'Country',
        fact_size: 'Size',
        fact_source: 'Source',
        boundary_title: 'Boundary',
        boundary_free_same: 'The same place is in {list} once more; that boundary is still free.',
        boundary_not_changed: 'The boundary was not changed: it took too long.',
        boundary_free_elsewhere: 'The same place is also in {list}; that boundary is still free.',
        choose_that: 'Choose that boundary',
        boundary_list_in_use: '{list}: already used by {title}',
        boundary_list_unavailable: '{list}: not available',
        partial_note: 'This boundary covers only the core area of {name}, not the whole area.',
        proxy_note: 'This is the area {name} is named after; the exact boundary is not available yet.',
        draw_note: 'The list has no boundary for {name}. You draw it; the community keeps the name and details from the list.',
        draw_boundary: 'Draw the boundary',
        reported_size: 'reported {size}',
        pick_hint: 'Choose an area from the results to see it on the map.',
        map: 'Map',
        satellite: 'Satellite',
        reset_view: 'Show the whole area',
        name_hint: 'Filled in from the list; you can change it.',
        free_instead: 'Draw it myself',
        in_use_error: '{name} was just chosen for another community. The results are updated.',
        sources: {
          unesco: 'UNESCO',
          eea: 'European Environment Agency (EEA)',
          wdpa: 'Protected Planet (WDPA)',
          osm: 'OpenStreetMap',
          research: 'Research dataset',
          national: 'National open data',
          arcgis: 'Published map layer',
          province: 'Provincial nature management map',
          other: 'Other source'
        }
      }
    },
    owner_register: {
      title: 'Register your organisation as an area owner',
      lead: 'You can start a community around land you manage. Before that, we check who you are.',
      what_happens: 'What happens after you register',
      step1_title: 'Create your account',
      step1_text: 'You get your owner page right away.',
      step2_title: 'We verify your organisation',
      step2_text: 'A Greenmapper admin checks your details. Your owner page shows the result.',
      step3_title: 'Create your communities',
      step3_text: 'Pick an official area or draw your own.',
      banner: 'After you register, a Greenmapper admin verifies your organisation. Until then you can see your owner page but not create communities.',
      stepper_account: 'Your account',
      stepper_organization: 'Your organisation',
      your_name: 'Your name',
      organization: 'Organisation',
      organization_too_long: 'Use at most {maxLength} characters',
      organization_required: 'Enter the name of your organisation',
      consent: 'I agree to the {link}.',
      privacy_statement: 'privacy statement for landscape organisations',
      consent_required: 'Agree to the privacy statement to continue.',
      submit: 'Create owner account',
      already_registered: 'Already registered?',
      log_in: 'Log in',
      created: 'Your owner account is ready.'
    },
    owner_dashboard: {
      create_community: 'Create community',
      strip_pending: 'Waiting for verification.',
      strip_rejected: 'Your registration was not approved.',
      strip_verified: 'Verified',
      text_pending: 'You can see your communities. Editing and creating open once a Greenmapper admin verifies your organisation.',
      text_rejected: 'You can still log in and see your communities. Changes stay closed.',
      text_verified: 'You can create and manage your communities.',
      title_pending: 'Your organisation is being checked',
      title_rejected: 'Your registration was not approved',
      lead_pending: 'A Greenmapper admin verifies {organization}. Until then your communities stay online for fans, and you can view them here.',
      lead_rejected: 'A Greenmapper admin could not verify {organization}. Your communities stay online for fans, and you can view them here.',
      feedback_label: 'Message from Greenmapper',
      got_it: 'Got it',
      new_badge: 'New',
      step_registered: 'Registered',
      step_registered_text: 'Your owner account exists.',
      step_verification_pending: 'Verification, now',
      step_verification_pending_text: 'No action needed from you.',
      step_verification_rejected: 'Verification, not approved',
      step_verification_rejected_text: 'See the message above.',
      step_manage: 'Manage communities',
      step_manage_text: 'Create and edit communities.',
      your_communities: 'My communities',
      official_area: 'Official area',
      drawn_area: 'Drawn area',
      boundary_drawn: 'boundary drawn by you',
      fans: 'no fans | 1 fan | {count} fans',
      summary_communities: 'no communities | 1 community | {count} communities',
      community_verified: 'verified by Greenmapper',
      community_status_pending: 'Waiting for review',
      community_fans_after_approval: 'Fans are added once the community is approved.',
      community_status_verified: 'Verified',
      community_status_rejected: 'Rejected',
      edit: 'Edit',
      edit_community: 'Edit {title}',
      community_status_changed: 'Changed · waiting for review',
      community_rejected_reason: 'Reason: {comment}',
      community_deleted: 'Your community “{title}” was deleted by Greenmapper.',
      view_only: 'View only',
      no_communities_verified: 'You have no communities yet. Create your first one.',
      no_communities_waiting: 'You have no communities yet. You can create them once you are verified.'
    },
    community_edit: {
      title: 'Edit community',
      back: 'Back',
      draw_title: 'Change boundary',
      change_boundary: 'Change boundary',
      official_read_only: 'Official boundary: it cannot be changed.',
      boundary_not_editable: 'This boundary cannot be changed here.',
      boundary_changed: 'New boundary, not saved yet',
      rereview_hint: 'After saving, Greenmapper checks the new boundary again.',
      zone_removed: 'A new boundary removes the fan zone: fans then count within the boundary.',
      use_boundary: 'Use this boundary',
      save: 'Save',
      saved: 'Changes saved',
      not_found: 'Community not found.',
      leave_title: 'Discard changes?',
      leave_text: 'Your changes have not been saved.',
      leave_draw_text: 'Your changes to the boundary will be lost. The boundary stays as it was.',
      leave_keep: 'Keep editing',
      leave_confirm: 'Discard'
    },
    admin_home: {
      title: 'Admin',
      text: 'Under construction: this will become the home page for admins.'
    },
    // the admin's e-mail templates and score settings (#341)
    email_templates: {
      title: 'Email templates',
      empty: 'No email templates found',
      col_key: 'Key',
      col_description: 'Description'
    },
    score_settings: {
      title: 'Score settings',
      empty: 'No score settings found',
      col_key: 'Key',
      col_description: 'Description',
      col_value: 'Score'
    },
    admin_fans: {
      title: 'Fans',
      search: 'Name, e-mail, tag or place',
      stat_day: 'New today',
      stat_week: 'New in 7 days',
      stat_month: 'New in a month',
      stat_year: 'New in a year',
      stat_total: 'All fans',
      col_name: 'Name',
      col_email: 'E-mail',
      col_created: 'Registered',
      col_age: 'Age',
      col_gender: 'Gender',
      col_score: 'Score',
      col_locale: 'Language',
      col_areas: 'Areas',
      col_funding: 'Funding',
      col_tags: 'Tags',
      col_subs: 'Follows',
      funding_finished: 'Funding finished',
      funding_not_finished: 'Funding not finished',
      empty: 'No fans found.',
      areas_title: 'Areas',
      no_areas: 'No areas drawn.',
      profile_title: 'Profile',
      log_title: 'Activity log',
      log_show: 'Show',
      log_hide: 'Hide',
      log_filter: 'Filter the log',
      log_empty: 'No log entries.',
      log_none_match: 'No entries match the filter.',
      log_failed: 'Could not load the log',
      log_session: 'Session',
      log_geometry: 'Geometry',
      log_scope: 'Scope',
      registration_finished: 'Registration finished',
      details: {
        user_id: 'User ID',
        created: 'Created',
        email_verified: 'E-mail verified',
        place: 'Place',
        disclaimer: 'Accepted the disclaimer',
        updated: 'Profile changed',
        education: 'Education',
        city: 'City',
        communities: 'Communities',
        no_communities: 'Follows no communities',
        gone_communities: '{count} no longer exists | {count} no longer exist',
        funding: 'Funding pledge',
        amount: 'Amount',
        reason: 'Reason',
        yes: 'yes',
        no: 'no'
      }
    },
    // the admin's communities screen (#341)
    admin_communities: {
      // the row menu's link to the community's area facts (#533)
      area_facts: 'Area facts',
      title: 'Communities',
      search: 'Name, owner or area',
      col_name: 'Community',
      col_owner: 'Owner',
      col_area: 'Area',
      col_created: 'Created',
      col_status: 'Status',
      col_fanzone: 'Fan zone',
      col_fans: 'Fans',
      col_threads: 'Threads',
      col_polls: 'Polls',
      col_polis: 'Polis',
      col_meetings: 'Meetings',
      col_pledges: 'Pledges',
      col_mods: 'Moderators',
      empty_waiting: 'No communities are waiting for review.',
      empty_rejected: 'No rejected communities.',
      empty_verified: 'No verified communities yet.',
      empty_all: 'No communities found.',
      more_actions: 'More actions for {title}',
      open: 'Open community',
      edit: 'Edit',
      pending_done: '{title} is waiting again',
      reject_title: 'Reject {title}?',
      facts_title: 'Community',
      description_title: 'Description',
      no_description: 'No description.',
      no_moderators: 'none',
      content: 'Content',
      fan_zone_fans: 'Fans in the zone',
      fan_zone_after_approval: 'added on approval',
      fan_zone_size: 'Fan zone',
      fan_zone_position: 'Position',
      fan_zone_start: 'Recommended',
      fan_zone_area: 'Area'
    },
    admin_owners: {
      title: 'Area owners',
      search: 'Name, email or organisation',
      tab_waiting: 'Waiting',
      tab_rejected: 'Rejected',
      tab_verified: 'Verified',
      tab_all: 'All',
      only_with_communities: 'Only owners with communities',
      only_migrated: 'Waiting since the migration ({count})',
      load_failed: 'Could not load owners',
      empty_waiting: 'Nobody is waiting for verification.',
      empty_rejected: 'No rejected owners.',
      empty_verified: 'No verified owners yet.',
      empty_all: 'No owners found.',
      status_pending: 'Waiting',
      status_rejected: 'Rejected',
      status_verified: 'Verified',
      personal_email: 'Personal email address',
      verify: 'Verify',
      reject: 'Reject',
      more_actions: 'More actions for {name}',
      delete_owner: 'Delete owner',
      rejected_with: 'Rejected with:',
      reject_reason: 'Why are you rejecting {name}?',
      reject_hint: 'The owner sees this on their owner page.',
      reject_delete_everything: 'Delete this owner and everything that belongs to them instead',
      reject_delete_hint: 'Removes the account, their communities and fan areas, and those communities from fans\' subscriptions. You confirm the details in the next step.',
      reject_delete_continue: 'Continue to delete',
      reject_owner: 'Reject owner',
      reject_title: 'Reject {name}?',
      reject_dialog_text: 'They can still log in and see your reason on their owner page. You can verify them later.',
      col_name: 'Owner',
      col_organization: 'Organisation',
      ago_now: 'now',
      ago_min: '{n} min',
      ago_hours: '{n} h',
      ago_days: '{n} d',
      ago_months: '{n} mo',
      ago_years: '{n} y',
      change_status: 'Change status',
      set_pending: 'Set to waiting',
      pending_done: '{name} is waiting again',
      undo: 'Undo',
      col_email: 'Email',
      col_status: 'Status',
      show_reason: 'Show reason',
      col_registered: 'Registered',
      col_communities: 'Communities',
      col_actions: 'Actions',
      col_area: 'Area',
      col_area_drawn: 'boundary drawn',
      // who counts as a fan (#96)
      col_fan_zone: 'Fan zone',
      fan_zone_col_area: 'area',
      fan_zone_col_proposal: 'recommended',
      fan_zone_title: 'Who counts as a fan',
      fan_zone_none: 'No fan zone: fans count within the boundary of the area.',
      fan_zone_size: 'Fan zone: {size}',
      fan_zone_position: 'Position: {position}',
      fan_zone_vs_start: '{change} compared with recommended',
      fan_zone_start: 'Recommended: {size}',
      fan_zone_area: 'Area: {size}',
      fan_zone_fans_waiting: 'Approving adds {count} fans',
      fan_zone_fans: 'Fans in the zone: {count}',
      fan_zone_failed: 'The fan zone could not be loaded.',
      col_verified: 'Verified',
      delete_title: 'Delete {name}?',
      delete_text: 'This permanently removes the owner account and:',
      delete_no_communities: 'no communities',
      delete_measures: 'no fan areas | 1 fan area | {count} fan areas',
      delete_type_to_confirm: 'Type {name} to confirm',
      delete_word: 'DELETE',
      delete_final: 'This cannot be undone.',
      delete_confirm: 'Delete owner | Delete owner and 1 community | Delete owner and {count} communities',
      verified_done: '{name} is verified',
      rejected_done: '{name} is rejected',
      deleted_done: '{name} is deleted',
      community_verified: 'Community {title} verified',
      community_reject: 'Reject',
      community_reject_title: 'Reject community',
      community_reject_text: 'The community keeps working for its fans. The owner sees your reason on their dashboard.',
      community_reject_reason: 'Why do you reject {title}?',
      community_rejected: 'Rejected',
      community_changed: 'changed',
      community_changed_was_verified: 'New boundary on {date}; was verified',
      community_changed_was_rejected: 'New boundary on {date}; was rejected',
      community_rejected_done: 'Community {title} rejected',
      community_reject_delete: 'Delete this community instead',
      community_reject_delete_hint: 'For fake or test communities. You see what will be removed in the next step.',
      community_delete_title: 'Delete {title}?',
      community_delete_text: 'This permanently deletes the community and:',
      community_delete_fans: 'no fans lose their subscription | 1 fan loses their subscription | {count} fans lose their subscription',
      community_delete_content: 'no posts, polls, meetings or pledges | 1 post, poll, meeting or pledge | {count} posts, polls, meetings and pledges',
      community_delete_official: 'the official area {name} becomes available again',
      community_delete_confirm: 'Delete community',
      community_delete_reason: 'Reason for the owner',
      community_delete_reason_hint: 'The owner sees this on their dashboard.',
      community_deleted_done: 'Community {title} is deleted'
    },
    maintenance: {
      title: 'Maintenance',
      subtitle: 'One-off data tasks for superadmins. Every run is logged on the server.',
      environment: {
        dev: 'Development',
        test: 'Test',
        production: 'Production'
      },
      load_failed: 'Could not load maintenance tasks',
      retry: 'Retry',
      empty: 'There are no maintenance tasks.',
      status: 'Current state',
      last_result: 'Result of {action} ({time})',
      unavailable: 'Not available in the current state',
      buttons: 'What the buttons do',
      run_failed: 'Task failed',
      run_done: '{action} finished',
      confirm_title: 'Are you sure?',
      confirm_message: 'You are about to run "{action}" of "{task}" on this environment.',
      confirm_changes: 'This changes data.',
      confirm_button: 'Run',
      cancel: 'Cancel',
      yes: 'Yes',
      no: 'No',
      todo_title: 'To do on this server',
      todo_none: 'Nothing to do on this server.',
      all_apply: 'Do everything',
      all_only_after: 'Do everything then only fixes and checks the shapes.',
      all_confirm: 'First the dry run of every step. When it passes, these steps run one after the other, in this order:',
      all_confirm_order: 'When the dry run fails nothing changes and you see why. A step that fails after that stops the rest; the steps before it stay done. Pruning to a sample is not part of it: that stays a button of its own. On production, make a database backup first.',
      all_result_apply: 'Do everything ({time})',
      'all_result_dry-run': 'Dry run failed, nothing changed ({time})',
      all_no_dry_run: 'No dry run: this step simply runs.',
      all_done: 'Everything done',
      'all_failed_dry-run': 'Dry run failed at {step}: nothing changed',
      all_failed_apply: 'Stopped: {step} failed',
      lists_title: 'Area lists',
      per_list: 'One list at a time',
      per_list_hint: 'Dry run, import, remove or prune a single list. Normally Import all lists above is enough.',
      other_tools: 'Other tools',
      // a test error for Sentry (#320)
      sentry: {
        title: 'Sentry test error',
        description: 'Causes a real error on this page, as a bug would. In Sentry it should show this environment and release, you as the user (id and e-mail), and the file and line in src/pages/AdminMaintenancePage.vue.',
        off: 'Sentry is off on dev: the error only goes to the browser console and logs/browser.log.',
        button: 'Cause a test error',
        col_release: 'Release',
        col_event: 'Sentry event',
        sent: 'Test error sent to Sentry: event {id}',
        thrown: 'Test error thrown (Sentry is off here)'
      },
      col_list: 'List',
      col_version: 'Version owners see',
      col_bundle: 'Newest bundle',
      col_entries: 'Entries',
      entries_note: 'Entries: everything in the list. The filters of Find your area count fewer: an area that is also in another list counts once there, under one list.',
      col_state: 'State',
      state_current: 'Up to date',
      state_newer: 'Newer bundle',
      state_not_imported: 'Not imported',
      state_sample: 'Sample',
      state_no_bundle: 'No bundle',
      details: 'Details',
      tasks: {
        'pledge-points-to-areas': {
          todo: {
            apply: '{points} pledges have a point as their place: turn them into small areas.'
          },
          title: 'Pledge points to areas',
          description: 'Gives every pledge whose place is a single point a small round area (50 m) around that point, as the pledge wizard draws areas only. The owner can redraw it. Make a database backup before applying on production.',
          help: {
            'dry-run': 'Counts the pledges with a point. Changes nothing.',
            apply: 'Turns those points into areas and remembers them, so Roll back can undo it.',
            rollback: 'Puts the points back on the pledges whose area is still the one Apply made; an area an owner redrew stays.'
          },
          actions: {
            'dry-run': 'Dry run',
            apply: 'Apply',
            rollback: 'Roll back'
          },
          fields: {
            points: 'Pledges with a point',
            communities: 'Communities with them',
            applied: 'Pledges changed by Apply (can be rolled back)',
            changed: 'Pledges changed',
            restored: 'Points put back',
            redrawn: 'Redrawn since (left alone)',
            unreadable: 'Points that cannot be read (left alone)',
            rolledBack: 'Rolled back (no to-do; Apply still possible)',
            gone: 'Deleted since (nothing to put back)'
          },
          unavailable: {
            'no-points': 'No pledge has a point.',
            'nothing-applied': 'Nothing applied to roll back.'
          }
        },
        'fan-subscriptions-cleanup': {
          todo: {
            apply: '{fans} fans follow a deleted community or one community twice: clean their subscriptions.'
          },
          title: 'Fan subscriptions cleanup',
          description: 'Cleans the fans\' subscriptions once: subscriptions to communities that no longer exist go, and a community a fan follows more than once is kept once. The fans\' scores stay as they are. Make a database backup before applying on production.',
          help: {
            'dry-run': 'Counts what would change. Changes nothing.',
            apply: 'Cleans those subscriptions. A fan who subscribes to something between the dry run and Apply is left for the next run. Make a database backup first on production.'
          },
          actions: {
            'dry-run': 'Dry run',
            apply: 'Apply'
          },
          fields: {
            fans: 'Fans to clean',
            fansWithGone: 'Fans following a deleted community',
            gone: 'Subscriptions to deleted communities',
            fansWithDuplicates: 'Fans following a community more than once',
            duplicates: 'Double subscriptions',
            changed: 'Fans cleaned',
            skipped: 'Fans skipped (changed meanwhile: run again)',
            landsWithoutId: 'Communities without an id'
          },
          unavailable: {
            clean: 'Nothing to clean.',
            'lands-without-id': 'Not possible: {landsWithoutId} communities have no id, so their subscriptions cannot be told from deleted ones.'
          }
        },
        'area-facts': {
          warnings: {
            none: 'Area facts are switched on, but there are no facts yet: download the outlines, build a bundle with build.py and import it (docs/claude/explain/area-facts.md).',
            missing: 'Communities without area facts: {n}. They come with the next bundle built from this site’s outlines (download the outlines, build.py, import).'
          },
          todo: {
            import: 'A new area facts bundle is waiting: {bundle}. Import it.'
          },
          title: 'Area facts',
          description: 'The facts of every community and fan place from open data (land cover, protected areas, GBIF records), built offline by docs/claude/polygon-lists/area-facts/build.py from the outlines downloaded here, and shown on a community\'s Area facts page. The downloads: the outlines for the builder (a fan only as a pseudonymous id), and the research export as CSV or GeoJSON (codebook: docs/claude/explain/area-facts.md).',
          help: {
            'switch-on': 'Switches the experiment on: the Area facts page, its item in the Communities menu and the downloads.',
            'switch-off': 'Switches the experiment off: the page, the menu item and the downloads go; the facts stay (Remove empties them).',
            'dry-run': 'Reads the newest bundle and counts what Import would keep and refuse. Changes nothing.',
            import: 'Replaces the area facts by the newest bundle\'s.',
            remove: 'Removes every area fact.',
            'download-outlines': 'Every community\'s and fan place\'s outline, for build.py: a fan only as a pseudonymous id, no name or e-mail.',
            'download-csv': 'One row per community and fan place: the facts, a fan\'s place answers, no personal fields.',
            'download-geojson': 'The same rows with their outlines.'
          },
          actions: {
            'switch-on': 'Switch on',
            'switch-off': 'Switch off',
            'dry-run': 'Dry run',
            import: 'Import',
            remove: 'Remove',
            'download-outlines': 'Download outlines',
            'download-csv': 'Download CSV',
            'download-geojson': 'Download GeoJSON'
          },
          fields: {
            on: 'On',
            bundle: 'Newest bundle',
            imported: 'Imported bundle',
            importedAt: 'Imported at',
            records: 'Facts',
            refused: 'Refused',
            withoutFacts: 'Without facts',
            lands: 'Communities',
            places: 'Fan places',
            file: 'File',
            size: 'Size (bytes)',
            version: 'Version',
            removed: 'Removed'
          },
          unavailable: {
            off: 'The experiment is switched off: switch it on first.',
            no_bundle: 'No bundle in _area-facts/bundles yet.',
            nothing: 'No area facts imported yet.'
          }
        },
        'log-sessions': {
          todo: {
            apply: '{rows} log rows hold a fan\'s login token as their session: replace them.'
          },
          title: 'Login tokens in the logs',
          description: 'Until #577 the add-area wizard and the funding survey stored the fan\'s login token as the session of each log row, so the rows held a way to log in as that fan. Replaces each such session with a random id; the rows of one login stay together.',
          help: {
            'dry-run': 'Counts the rows and sessions. Changes nothing.',
            apply: 'Replaces those sessions with random ids. Cannot be undone, and is not meant to be.'
          },
          actions: {
            'dry-run': 'Dry run',
            apply: 'Apply'
          },
          fields: {
            rows: 'Rows with a login token',
            sessions: 'Sessions (visits)'
          },
          unavailable: {
            clean: 'Nothing to replace.'
          }
        },
        'score-duplicates': {
          todo: {
            apply: '{extra} score settings exist twice (a data import): remove the extra copies.'
          },
          title: 'Doubled score settings',
          description: 'Removes the second copy of the score settings (Draw an area, Virtual funding, Discussion comment, Pledge) that a data import left: the Scores page listed each twice, and a change reached only one copy. Keeps the copy the test server has, else the first. A setting whose copies differ is left for you. Every removed copy is kept: Roll back puts them back. Do everything runs it after a deploy; after a Roll back it waits for Apply by hand.',
          help: {
            'dry-run': 'Lists the doubled settings and counts the copies Apply would remove. Changes nothing.',
            apply: 'Removes the extra copies, one per setting kept.',
            rollback: 'Puts back every copy Apply removed.'
          },
          actions: {
            'dry-run': 'Dry run',
            apply: 'Apply',
            rollback: 'Roll back'
          },
          fields: {
            extra: 'Extra copies',
            keys: 'Doubled settings',
            differing: 'Copies that differ (left as they are)',
            removed: 'Copies removed',
            appliedAt: 'Last apply',
            rolledBackAt: 'Rolled back at',
            changedSince: 'A score changed since',
            restored: 'Copies put back'
          },
          unavailable: {
            clean: 'Nothing doubled.',
            'nothing-applied': 'Nothing applied to roll back.',
            'changed-since': 'Not possible any more: a score was changed since Apply, and the old copy would double it with another value.'
          },
          warnings: {
            'values-differ': 'The copies of {keys} have different values: the score depends on which copy the database returns. Remove the wrong copy by hand.'
          }
        },
        'owner-status-migration': {
          todo: {
            apply: 'The owner status migration has not been applied on this server yet.'
          },
          title: 'Owner status migration',
          description: 'Gives every existing owner without a status the status waiting, also owners who are admin. An admin then verifies each owner by hand on the Area owners screen. Make a database backup before applying on production.',
          help: {
            'dry-run': 'Counts the owners without a status; all of them would become waiting. Changes nothing. The count is remembered and compared with what Apply changes.',
            apply: 'Makes those owners waiting, once. Afterwards: open Area owners, tick "Waiting since the migration" and verify the genuine owners, the ones with communities and fans first. Until then they cannot manage their communities. Make a database backup first on production.',
            rollback: 'Removes the status again from exactly the owners Apply changed. Only possible as long as no admin has verified or rejected one of them: after that it switches itself off.'
          },
          actions: {
            'dry-run': 'Dry run',
            apply: 'Apply',
            rollback: 'Roll back'
          },
          fields: {
            applied: 'Applied',
            appliedAt: 'Applied at',
            owners: 'Owners',
            pending: 'To waiting',
            dryRunOwners: 'Owners in the dry run before',
            adminDecisions: 'Decided by an admin since',
            rolledBack: 'Owners rolled back'
          },
          unavailable: {
            'admin-decided': 'Not possible any more: an admin has already decided on {adminDecisions} of the migrated owners, and rolling back would undo that.'
          },
          warnings: {
            'count-differs': 'Apply changed {applied} owners, but the dry run before it counted {dryRun}. Check on the Area owners screen whether the right owners are waiting.'
          }
        },
        'geometry-check': {
          todo: {
            never_run: 'The geometry check has never run on this server.'
          },
          title: 'Geometry check',
          description: 'Checks every fan\'s place, every community boundary and every home for defects: missing or broken shapes, crossing lines, shapes in the wrong place (at 0,0, latitude and longitude swapped, far from home), far too small or too large, impossible levels, duplicates and orphans. Reads only: it changes nothing. Runs in the background; the counts show here when it is done.',
          help: {
            run: 'Checks this environment\'s database.',
            'run-copy': 'Checks the database copy set up for it (settings: geometryCheck.copyUrl), e.g. a copy of production restored on dev.'
          },
          actions: {
            run: 'Run check',
            'run-copy': 'Check the copy'
          },
          fields: {
            lastRun: 'Last run',
            state: 'State',
            source: 'Database',
            startedAt: 'Started',
            finishedAt: 'Finished',
            checked: 'Checked',
            defects: 'Defects',
            error: 'Error',
            started: 'Check started'
          },
          unavailable: {
            running: 'A check is running.',
            'no-copy': 'No database copy is set up.'
          }
        },
        'geometry-fix': {
          title: 'Geometry fixes',
          description: 'Fixes the fans\' places as decided in issue #76: shapes whose lines cross are untangled, double-click points removed, shapes past the edge of the map shifted back or clipped, places at 0,0 moved to the fan\'s home, copies and places of deleted users deleted, impossible levels put right, and a fan who finished registering gets a place at every level (missing ones made up around home, marked as made up). Every changed place\'s old version is kept: Roll back puts everything back.',
          help: {
            'dry-run': 'Counts what each fix would change in this database. Changes nothing.',
            apply: 'Carries out all fixes at once in this database. Make a database backup first on production.',
            rollback: 'Puts back everything the last Apply changed, from the old versions it kept.',
            'dry-run-copy': 'Dry run on the database copy (settings: geometryCheck.copyUrl).',
            'apply-copy': 'Apply on the database copy.',
            'rollback-copy': 'Roll back on the database copy.'
          },
          actions: {
            'dry-run': 'Dry run',
            apply: 'Apply',
            rollback: 'Roll back',
            'dry-run-copy': 'Dry run (copy)',
            'apply-copy': 'Apply (copy)',
            'rollback-copy': 'Roll back (copy)'
          },
          fields: {
            lastRun: 'Last apply',
            lastRunCopy: 'Last apply on the copy',
            run: 'Run',
            changes: 'Changes',
            left: 'Cannot be fixed'
          },
          unavailable: {
            'no-copy': 'No database copy is set up.',
            'nothing-applied': 'Nothing applied to roll back.'
          }
        },
        'polygon-lists': {
          title: 'All area lists',
          description: 'Imports every list with a newer bundle in one go, then applies the area groups once.',
          help: {
            'import-all': 'Imports the newest bundle of every list that has a newer one than owners choose from (or was never imported), one list after the other, then applies the area groups once. Lists that are up to date are skipped. Large lists (WDPA) take many minutes.',
            'prune-all': 'Test server only. Prunes every whole list to its sample of about 100 areas (the same every time); areas a community is on stay.'
          },
          actions: {
            'import-all': 'Import all lists',
            'prune-all': 'Prune all lists to samples'
          },
          fields: {
            lists: 'Lists',
            active: 'Lists owners choose from',
            withBundle: 'Lists with a bundle',
            toPrune: 'Whole lists to prune',
            toImport: 'Newer bundles to import',
            samples: 'Lists that are samples',
            imported: 'Imported',
            pruned: 'Pruned to a sample',
            groups: 'Area groups',
            groupsFile: 'Area groups file'
          },
          unavailable: {
            all_current: 'Every list is up to date.',
            all_samples: 'Every list is a sample already.',
            no_bundles: 'There are no bundles in the import folder.',
            nothing_imported: 'No list has been imported yet.',
            small_lists: 'The whole lists have 100 entries or fewer.'
          },
          todo: {
            import: 'New bundles to import: {lists}.'
          }
        },
        'polygon-list': {
          title: 'Area list: {list}',
          description: 'Imports this polygon list from the newest bundle in its folder (<import folder>/<list>/bundles), checked against its .sha256 file. A list has one version: Import loads the new entries next to the old ones, switches the list over when everything is in, then deletes the old entries. There is no roll back: to go back, put an older bundle in the folder and import it. Communities keep their own boundary and details whatever happens to the list.',
          help: {
            'dry-run': 'Reads the newest bundle and checks every entry. Shows how many entries it has, per status, and any problems. Changes nothing.',
            import: 'Imports the newest bundle and makes it the version owners choose from, replacing the version that was there. Refused when an entry has a problem (see Dry run); nothing changes then.',
            remove: 'Takes the list away from owners and deletes all its entries. Communities on it keep their boundary and details.',
            prune: 'Test server only. Keeps about 100 varied areas of this list (statuses, sizes, first letters, countries, with and without a fan outline) and deletes the rest, so test stays small and fast. The same areas every time. Areas a community is on are always kept. To get the full list back, Import it again.'
          },
          actions: {
            'dry-run': 'Dry run',
            import: 'Import',
            remove: 'Remove list',
            prune: 'Prune to sample'
          },
          fields: {
            listKey: 'List',
            bundle: 'Newest bundle',
            bundleMB: 'Size (MB)',
            activeDatasetVersion: 'Version owners see',
            importedFile: 'Imported bundle',
            importedAt: 'Imported at',
            entries: 'Entries in the database',
            file: 'File',
            sha256: 'Checksum',
            datasetVersion: 'Version in the bundle',
            withPolygon: 'With polygon',
            problems: 'Problems',
            problemExamples: 'Examples of problems',
            currentVersion: 'Current version',
            currentEntries: 'Current entries',
            official: 'Official boundary',
            accepted: 'Accepted',
            partial: 'Core area only',
            proxy: 'Approximate area',
            review: 'To review (owner draws)',
            missing: 'No polygon (owner draws)',
            imported: 'Imported',
            removedOld: 'Old entries removed',
            communities: 'Communities on this list',
            aliases: 'Copies merged into another entry (aliases)',
            movedCommunities: 'Communities moved from a copy to its entry',
            notMovedCommunities: 'Communities left on a copy (its entry has one)',
            removed: 'Entries removed',
            listRemoved: 'List removed',
            groupedEntries: 'Entries in an area group',
            groupsFile: 'Area groups file',
            groups: 'Area groups',
            groupsError: 'Area groups not applied',
            prunedAt: 'Pruned to a sample at',
            prunedFrom: 'Entries before pruning',
            kept: 'Entries kept',
            sample: 'In the sample',
            keptInUse: 'Kept because a community is on them'
          },
          unavailable: {
            no_bundle: 'There is no bundle in this list’s folder.',
            not_imported: 'The list has not been imported yet.',
            already_pruned: 'The list is already a sample. Import it again for the full list.',
            small_list: 'The list has 100 entries or fewer already.'
          },
          warnings: {
            groups_stale: 'The area groups ({file}) were made for another version of the list “{list}”: its entries are in no group. Run groups.py for the lists as they are now and copy the new file into the _groups folder.',
            groups_waiting: 'A newer area groups file ({file}) is in the _groups folder: it is applied at the next import of a list or when the server starts.'
          }
        }
      }
    },
    home: {
      title: 'Home'
    },
    moderators: {
      title: 'Moderators',
      mod_requests: 'Moderator requests',
      mods: 'Moderators',
      accept: 'Accept',
      deny: 'Deny'
    },
    create_community: {
      title: 'Create community'
    },
    land_owner_register: {
      title: 'Land owner registration',
      steps: {
        general: {
          nav_title: ' General info',
          title: 'Land owner information',
          task_title: 'Proveide general information for the land you own',
          email: 'Email'
        },
        draw: {
          nav_title: 'Map',
          title: 'Draw area',
          task_title: 'Draw your area'
        },
        description: {
          nav_title: 'Description',
          title: 'Describe your community',
          task_title: 'Provide a title that represents your community',
          input_title: 'Titel',
          input_title_error: 'Maximum of {max} characters',
          input_description: 'Description',
          task_description: 'Describe what makes this particular community attractive, valuable or important',
          input_description_error: 'Maximum of {max} characters'
        },
        finalize: {
          title: 'Information',
          task_title: 'Thank you for supplying this information, if you click next we will finalize your community. To discuss topics with your community you can open a thread. Click on the 3 dots to the right of \'threads\' to add a new thread and discuss a new topic.'
        }
      }
    },
    pledge: {
      count: 'Total number of pledgers',
      part1: 'pledged of',
      part2: 'goal',
      question: 'Would you like to <b>pledge</b> your virtual funds to this project?',
      yes: 'Yes, I <b>do</b> want to pledge to this project',
      no: 'No, I <b>don\'t</b> want to pledge to this project',
      delete_title: 'Delete pledge',
      delete_text: 'Do you really want to delete this pledge?'
    },
    add_pledge: {
      title: 'Provide the amount of funding you would like to pledge to this project.',
      reason: 'Would you please elaborate on why you have chosen this amount?',
      reasonNo: 'Would you please elaborate why you don\'t want to pledge to this project?',
      confirm_text1: 'You are currently proposing to pledge',
      confirm_text2: 'of your indicated yearly nature budget to this project. Would you kindly confirm this amount?',
      confirm: 'I confirm',
      budget_hint: 'Your nature budget: € {amount} a year'
    },
    add_treasure: {
      title_nav: 'Add Treasure',
      photos: 'Photos',
      title: 'Upload photos of treasures',
      description: 'Picture why you love this place. Share a drawing, a poem, a picture or a short story.',
      upload: 'Upload photos (.jpg)',
      describe_title: 'Provide a title that represents your treasure',
      describe_text: 'State in your own words what makes this treasure attractive, valuable or important to you',
      pin_hint: 'Tap the map where your treasure is.',
      pin_move: 'Drag the pin, or tap elsewhere, to move it.',
      pin_outside: 'This place lies outside the community\'s area.',
      show_area: 'Show the whole area'
    },
    create_pledge: {
      title_nav: 'Add pledge',
      title: 'Describe your financing request with one catchy title.',
      description: 'Describe your financing request in more detail. Provide background information, proposed actions, envisioned results and what your pledgers will receive in return.',
      type: 'Pledge type',
      fixed: 'Fixed',
      fixed_desc: 'Request for one-time funding',
      yearly: 'Yearly',
      yearly_desc: 'Request for funding repeating yearly',
      '2yearly': '2-Yearly',
      '2yearly_desc': 'Request for funding repeating every 2 years',
      '3yearly': '3-Yearly',
      '3yearly_desc': 'Request for funding repeating every 3 years',
      '4yearly': '4-Yearly',
      '4yearly_desc': 'Request for funding repeating every 4 years',
      '5yearly': '5-Yearly',
      '5yearly_desc': 'Request for funding repeating every 5 years',
      goal: 'State your pledge goal in euros.',
      goal_error: 'At most € {max}',
      map_title: 'Draw the area of your pledge',
      map_outside: 'Part of your area lies outside the community\'s area.'
    },
    edit_pledge: {
      title_nav: 'Edit pledge'
    },
    create_message: {
      sent: 'The message has been sent',
      no_communities: 'No communities',
      title_nav: 'Create message',
      steps: {
        community: {
          nav_title: 'Community',
          ask: 'Choose the <b>community</b> to send the message to. It goes to <b>all</b> its members.',
          title: 'Select the <b>community</b> to sent the message to its <b>all fans</b> ect</p>'
        },
        message: {
          nav_title: 'Message',
          title_ask: 'Give your message a short and catchy title.',
          body_ask: 'Describe what it is about, give background and say what you expect the members to do. Keep it short and specific.'
        },
        finalize: {
          nav_title: 'Finalize',
          ask: 'This is how the members of the community will see it.'
        }
      }
    },
    create_thread: {
      title_nav: 'Create discussion',
      title_nav_edit: 'Edit discussion',
      title: 'Provide a title',
      description: 'Provide a first post',
      upload: 'Upload photos (.jpg)'
    },
    create_poll: {
      preview: 'Preview',
      title_nav: 'Create poll',
      title_nav_edit: 'Edit poll',
      title: 'Provide a title',
      description: 'Provide a first post',
      upload: 'Upload photos (.jpg)',
      options: 'Add poll options',
      option: 'option'
    },
    create_polis: {
      id_label: 'Polis id',
      title_nav: 'Create Polis',
      title_nav_edit: 'Edit Polis',
      title: 'Provide a title',
      id: 'Provide a polis ID',
      voter_option: 'Only subscribed users can vote'
    },
    create_meeting: {
      date: 'Date',
      time: 'Time',
      title_nav: 'Create meeting',
      title_nav_edit: 'Edit meeting',
      title: 'Provide a title',
      description: 'Provide a description',
      url: 'Provide external url of meeting',
      dateTime: 'Start time & date'
    },
    send_invites: {
      title_nav: 'Send invites',
      step: 'Select',
      number: 'Number of randomly invited members',
      number_label: 'Number of invites',
      max_error: 'At most {max} invites',
      sent: 'The e-mails have been sent'
    },
    meeting: {
      deleted: 'The meeting has been deleted',
      delete_title: 'Delete meeting',
      delete_text: 'Are you sure you want to delete this meeting?',
      total_subs: 'Total subscribers',
      accepted_invites: 'Accepted Invites',
      rejected_invites: 'Rejected Invites',
      planned_label: 'planned on',
      invited_banner: 'You have been invited for the meeting',
      accepted_banner: 'You have accepted the invite, if you are selected you will be emailed with further details about the meeting.',
      rejected_banner: 'You have declined the invite for the meeting',
      send_banner: 'Send the link of the meeting to subscribers that have accepted the invite.',
      resend_banner: 'Resend the link of the meeting. Warning you have already send the links!'
    },
    landing: {
      my_portal: 'My Xena'
    },
    welcome: {
      // the links between the visitor's pages (#442)
      no_account: 'No account yet?',
      to_register: 'Create an account',
      have_account: 'Already have an account?',
      to_login: 'Log in',
      back_to_login: 'Back to log in',
      title: 'Welcome to Greenmapper',
      introduction: 'Introduction',
      subtitle_1: 'Mark nature and landscape places',
      paragraph_1: 'In Greenmapper Friends you can mark <b>nature or landscape</b> places with <b>green and/or water</b> that you find <b>attractive, valuable, or important</b>. A place can be small or large, in or outside a city or village. You may visit it often, rarely, or mainly know it from stories or photos.',
      subtitle_2: 'Why register?',
      paragraph_2: 'Your marked place is a place you can be an <b>online friend</b> of. That’s why we ask a few details to create an account. Only your <b>screen name</b> is visible to other users.',
      subtitle_3: 'Privacy policy',
      paragraph_3: 'Greenmapper Friends is an initiative of the University of Groningen. Greenmapper Friends stores your emailaddress in the Greenmapper Landscape Friend Registry (GLFR). No one can access this email accept the Greenmapper organisation. You can via the GLFR be reached anonymously by land-owners, land management, or other friends of the area. But these third parties do not have direct access to your email. We follow the European General Data Protection Regulation guidelines for privacy and the storage of your personal data.',
      continue_without_account: 'Continue without account',
      forgot_password: 'Forgot password?',
      forgot_password_dialog: 'Enter your email address. You will get a link to choose a new password.'
    },
    introduction: {
      title: 'Introduction',
      text: 'In Greenmapper Friends, you can <b>mark nature</b> or <b>landscape places</b> that you find <b>attractive, valuable, or important</b>. These areas have to be places with greenery, water or nature. You can think of a place in a park, at a lake, at sea, in a forest, a meadow, a field of flowers, a spot to watch birds etc. It can be a place within or outside a city or town, small or large. You may visit them often or never! As long as it is a natural place that you find attractive or valuable or is meaningful for you.',
      start_btn: 'Start survey'
    },
    register: {
      email_sublabel: 'not visible to others',
      name_sublabel: 'visible to others',
      name_hint: 'for example a nickname or first name',
      address_search_sublabel: '±200 m is enough',
      password_hint: 'minimum 8 characters',
      map_preview_hint: 'Select a home location to preview it on the map',
      use_my_location: 'Use my location',
      geolocate_failed: 'Could not get your location. Check permissions or search instead.',
      location_not_found: 'No location found for that search. Try a city, address, or postcode.',
      disclaimer_title: 'Disclaimer Greenmapper Friends',
      disclaimer: 'Greenmapper Friends stores your email address in the Greenmapper Landscape Friend Registry (GLFR). No one can access this email accept Greenmapper Friends. You can via the GLFR be reached anonymously by land-owners, land management, or other friends of the area. But these third parties do not have direct access to your email or personal data. We also ask your home location. We only do this to show you a map of your surroundings by default. We follow the European General Data Protection Regulation guidelines for privacy and the storage of your personal data. Read more details'
    },
    info_contact: {
      title: 'About',
      contact: 'Contact',
      disclaimer_title: 'Disclaimer',
      implementation: 'Implementation: '
    },
    map: {
      title: 'Overall community map',
      add_btn: 'Draw a new area',
      share_title: 'Share map url',
      share_btn: 'Copy to clipboard',
      hint_on_add: 'Place the dot on the map to start drawing',
      hint_on_end_draw: 'You can still modify the area.',
      zoom_to_area_btn: 'Zoom to area',
      details_btn: 'View details',
      menu_btn: 'Map options',
      layers_btn: 'Map or satellite',
      gps_btn: 'Go to my location',
      home_btn: 'Go to my home' // share_desc: 'Share'

    },
    timeline: {
      title: 'Timeline',
      rating: 'Rating',
      rating_subtext: 'Personal rating of the marked area',
      visit_frequency: 'Visit frequency',
      visit_frequency_subtext: 'How often the area is visited',
      activities: 'Activities',
      activities_subtext: 'Activities reported at marked area',
      add_btn: 'Add an area',
      edit_btn: 'Edit area',
      delete_btn: 'Remove area',
      delete_title: 'Remove area',
      delete_subtitle: 'Are your sure?'
    },
    add_area_info: {
      title: 'Add area',
      add_btn: 'Add an area'
    },
    my_areas: {
      open_btn: 'Show in Google Maps',
      title: 'My areas',
      sub_title: 'All the nature related places I find attractive, valuable or important.',
      created_areas: 'Created areas',
      joint_surface: 'Joint surface (km2)',
      and_section_eyebrow: 'Greenmapper Attractive Nature Database',
      and_section_title: 'Your four scale favorite places',
      and_complete_badge: 'All four scales complete',
      free_section_title: 'Places you added yourself'
    },
    my_communities: {
      open_btn: 'Open community',
      title: 'My communities',
      sub_title: 'All the areas of land owners or land management that overlap with my areas. Here I can be reached as a friend of those areas.',
      delete_btn: 'Unsubscribe',
      delete_title: 'Unsubscribe',
      delete_subtitle: 'Are you sure you want to unsubscribe from this community?',
      befriended_communities: 'Befriended communities',
      joint_surface: 'Joint surface (km2)'
    },
    info: {
      text1: 'Greenmapper Friends is developed by Greenmapper. For more information please have a look at the Greenmapper',
      text2: 'If you have any questions or you want to contact us, please drop us an email at:',
      text3: 'With Greenmapper Friends we try to keep the  application and data as accurate and free of errors as possible. Should the app -despite our efforts- contain incomplete or inacurate information, then we cannot accept responsibility for that.',
      text4: 'We reserve the right to change, remove or add material without any prior notice. Greenmapper Friends  accepts no liability for any information contained on websites to which we refer via hyperlinks.'
    },
    my_owned_communities: {
      title: 'My communities',
      owned_communities: 'Owned communities',
      total_subs: 'Total subscribers',
      joint_surface: 'Joint surface (km2)'
    },
    community: {
      report_title: 'Report content',
      report_subtitle: 'Are you sure you want to report this content for moderation?',
      report_hint: 'Type a reason',
      delete_title: 'Delete content',
      delete_subtitle: 'Are you sure you want to delete this content?',
      discussions_title: 'Discussions',
      discussions_subtitle: 'Open discussion on any topic',
      poll_title: 'Poll',
      poll_subtitle: 'Simple polling and voting for options',
      polis_title: 'Polis',
      polis_subtitle: 'Click on one of the subjects below to start pol.is polling',
      pledges_title: 'Support projects!',
      pledges_subtitle: 'Virtually pleding of funds for biodiversity, landscape quality or sustainable services',
      meetings_title: 'Meetings',
      meetings_subtitle: 'In-depth online workshop or council of friends',
      RMS_dialog_title: 'Request moderator status',
      RMS_dialog_text: 'Do you want to send a request to become moderator for this community?',
      more_btn: 'More options',
      to_map_btn: 'Show on the map',
      treasures_title: 'Treasures',
      show_report_btn: 'Show report',
      join_btn: 'Join community'
    },
    poll: {
      deleted: 'The poll has been deleted',
      label: 'Poll',
      delete_title: 'Delete poll',
      delete_text: 'Are you sure you want to delete this poll and its votes?',
      votes: 'votes',
      voted: 'You have voted'
    },
    polis: {
      deleted: 'The Polis conversation has been deleted',
      delete_title: 'Delete Polis conversation',
      delete_text: 'Are you sure you want to delete this Polis conversation from the community?',
      text: 'Click "Active third-party translation" to see the comments in your default language. For each statement, you can vote ‘agree’, ‘disagree’ or ‘pass/unsure’.',
      text2: 'You can submit your opinion or statement, so others can vote on your ideas.'
    },
    account: {
      edit_title: 'Edit profile',
      saved: 'Profile saved',
      signout_title: 'Sign out'
    },
    create_area: {
      title: 'Create area',
      add_title: 'Add area',
      home_title: 'Place home marker',
      pauze_title: 'Are you sure?',
      pauze_text: 'Pauze the registration and continue later',
      map_tips: 'Map tips',
      search_place: 'Search for a place',
      search_not_found: 'Nothing has been found',
      zoom_smaller: 'Smaller',
      zoom_bigger: 'Bigger',
      area_reset: 'Area reset',
      reset_polygon: 'Reset polygon',
      reset_polygon_title: 'Reset polygon?',
      reset_polygon_text: 'This restores the polygon to how it looked before you started editing.',
      leave_polygon_edit_title: 'Leave polygon edits?',
      leave_polygon_edit_text: 'Going back resets your polygon to the circle selection. Your point edits will be lost.',
      polygon_guard: {
        cross: 'Lines must not cross',
        spacing: 'Points must not get too close',
        edge: 'Point must not get too close to another side',
        angle: 'Corner cannot become that sharp',
        area: 'Area cannot become that small',
        bounds: 'Point stays within the visible map area',
        too_few: 'Area needs at least 3 points',
        not_closed: 'Shape is not closed',
        duplicate: 'Two points are in the same place',
        range: 'Point lies outside the valid map range',
        invalid: 'This shape cannot be saved'
      },
      loading: {
        title: 'Preparing map',
        opening: 'Opening map…',
        loading_account: 'Loading account…',
        loading_areas: 'Loading your areas…',
        loading_home: 'Loading home…'
      },
      hints: {
        place_above_area: 'Place over your area',
        place_area_here: 'Place fully inside',
        drag_vertex: 'Drag points to fit your place',
        zoom: 'Zoom in and out',
        at_edge: 'You have reached the edge of this area'
      },
      stepper: {
        description: 'Description',
        rate: 'Rating',
        visit_freq: 'Visiting frequency',
        activities: 'Activities',
        connected: 'Online connected'
      },
      steps: {
        level: {
          nav_title: 'Level',
          title: 'Choose level',
          task_title: 'select your level of area',
          options: {
            neighborhood: 'neighborhood / local',
            living_area: 'region / regional',
            country: 'country',
            world: 'world'
          }
        },
        map: {
          nav_title: 'Map',
          title: 'Draw area',
          task_title: 'Draw your area'
        },
        description: {
          nav_title: 'Describe',
          title: 'Describe your area',
          task_title: 'What do you call this area?',
          input_title: 'Titel',
          input_name: 'Name',
          input_title_error: 'Maximum of {max} characters',
          input_description: 'Description',
          task_description: 'Why is this area attractive, valuable and/or important?',
          input_description_error: 'Maximum of {max} characters'
        },
        rate: {
          nav_title: 'Rating',
          title: 'Rate your area',
          task_title: '(Score: 1 = bad, 6 = average, 10 = perfect)'
        },
        visit_freq: {
          nav_title: 'Visit',
          title: 'How often do you visit your area?',
          options: {
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
            few_times_a_year: 'Few times a year',
            yearly: 'Yearly',
            rarely: 'Rarely',
            never: 'Never'
          }
        },
        activities: {
          nav_title: 'Activities',
          title: 'What activities do you engage in at this area?'
        },
        priority: {
          nav_title: 'Priority',
          title: 'Should this place be:',
          options: {
            maintained: 'Maintained (= keep it as it is)',
            strengthened: 'Strengthened (= improve its qualities)'
          }
        },
        relationship: {
          nav_title: 'Relation',
          title: 'What is your relationship to this area',
          options: {
            tourist: 'Tourist',
            inhabitant: 'Inhabitant',
            work: 'Work-related'
          }
        },

        /*
                        finished: {
                            '1_title': 'Thank you! Your first place is now on the map',
                            '1_text': 'Even this first contribution already helps us better understand which natural places people value. You can add another place now or come back later (via the button in the top right)',
                            '2_title': ' Great — your personal map is starting to take shape',
                            '2_text': 'Each place you add helps make visible what deserves protection. You can add another place now or come back later (via the button in the top right',
                            '3_title': 'Thank you! Your contribution is already providing valuable insights into nature and landscape',
                            '3_text': 'Adding one more place will complete your map — but you can also continue later (via the button in the top right)',
                            '4_title': 'Wonderful — your personal map is now complete!',
                            '4_text': 'Your contribution helps researchers and managers better understand which places people want to preserve and protect. You will soon see an overview of your places. First, we have one short question about possible financial support for your areas'
                        }
        */
        finished: {
          '1_title': 'Thank you! Your first place is now on the map',
          '1_text': 'Even this first contribution already helps us better understand which natural places people value.',
          '2_title': ' Great — your personal map is starting to take shape',
          '2_text': 'Each place you add helps make visible what deserves protection.',
          '3_title': 'Thank you! Your contribution is already providing valuable insights into nature and landscape',
          '3_text': 'Adding one more place will complete your map.',
          '4_title': 'Wonderful — your personal map is now complete!',
          '4_text': 'Your contribution helps researchers and managers better understand which places people want to preserve and protect. You will soon see an overview of your places. First, we have one short question about possible financial support for your areas'
        }
      },
      _edit: {
        title: 'Update area'
      },
      welcome: {
        title: 'Draw areas and answer questions',
        subtitle: 'Mark four nature places at different scales and share why they matter to you.',
        sheet_text: 'See the overview below. Press Next to draw your first neighbourhood area.',
        how_it_works_title: 'What you do at each level',
        step_draw: 'Mark an area on the map',
        step_questions: 'Answer questions about your place',
        step_next_level: 'Repeat for 4 scales',
        journey_title: 'Four scales, four places',
        video_caption: 'Short guide on how to draw an area'
      },
      welcome_v3: {
        greeting: 'Welcome to Greenmapper Friends',
        title: 'Mark your nature place',
        intro: 'Mark places with greenery, water, or landscape that you find attractive, valuable, or important.',
        levels_title: 'Four scales',
        levels_intro: 'Choose one place at each level.',
        checklist_title: 'What you do at each level',
        step_draw: 'Draw the place as an area on the map.',
        step_adjust: 'Adjust the shape and confirm the area.',
        step_questions: 'Answer a few questions about why this place matters to you.',
        step_repeat: 'Repeat these steps for the next scale level.',
        repeat_hint: 'You start in your neighborhood. After the questions, continue with region, country, and world.',
        start_btn: 'Start with Neighborhood'
      },
      welcome_v4: {
        title: 'Mark your nature place',
        title_next: 'Next place: {level}',
        intro: 'Mark places with greenery, water, or landscape that you find attractive, valuable, or important.',
        intro_next: 'Continue with {level}. Mark a place with greenery, water, or landscape that you find attractive, valuable, or important.',
        checklist_title: 'What you do at each level',
        start_badge: 'Start',
        now_badge: 'Now',
        done_badge: 'Done',
        progress: 'Place {current} of 4',
        start_btn: 'Start with {level}',
        continue_btn: 'Continue with {level}'
      }
    },
    edit_area: {
      title: 'Update area'
    },
    funding: {
      not_eligible: 'Unfortunately, you do not meet the requirements to take part in the funding survey: it asks about at least two of your own areas.',
      title: 'Virtual Nature & Community funds',
      // the wizard's bar (the whole name was cut off, the user's review of #493)
      title_nav: 'Nature fund',
      nav_intro: 'Introduction',
      nav_amount: 'Amount',
      nav_locations: 'Locations',
      nav_objectives: 'Objectives',
      nav_finalize: 'Finalize',
      intro1: 'Hi!',
      intro2: 'Thank you for joining the Greenmapper experiment on nature funding.',
      intro3: 'In this section you use a <b>Virtual Nature & Community Fund</b>. You show how you would allocate a <b>hypothetical</b> yearly nature budget — <b>without actually paying</b>. Together with other participants, this helps managers and policy makers understand what people find important.',
      intro4: '<h6>How it works in 3 steps:</h6>',
      step1: 'Confirm your total yearly nature budget',
      step2: 'Allocate it across your 4 areas',
      step3: 'Allocate per area across goals: biodiversity, landscape, sustainable business, culture, other',
      caption: 'Trunk = area • Branches = goals • Apples = example projects.',
      intro5: '<b>Practical</b>: 5–8 min • anonymous • no right/wrong answers.',
      intro6: 'As a thank you, <b>we donate €5 to nature on Texel </b> after you complete this section.',
      amount1: 'Virtual funding amount',
      amount2: 'What would you — if it were really possible — like to spend per year on your favorite natural areas? It concerns a fictitious amount, but try to choose a figure that feels realistic to you.',
      amount3: 'Enter your (virtual) annual nature budget below.',
      amount4: 'Could you briefly explain why you chose this amount? For example, what you find important to support, or how you decided on this amount.',
      amount5: 'yearly budget',
      max: 'Maximun amount 5000 euro',
      min: 'Minimun amount 1 euro',
      locations1: 'Allocate your budget across your favorite natural areas',
      locations2: 'Indicate how you would divide your chosen (virtual) budget among the Virtual Nature and Community Funds of your favorite natural areas.',
      locations3: 'Could you briefly explain how you made your distribution? Why did you choose to divide it this way?',
      objectives1: 'Budget allocation between funding objectives',
      objectives2: 'Here you can see your distribution across the Virtual Nature and Community Funds for your area. You can do this for your favorite areas in your neighborhood, region, country, and worldwide. Indicate how you would divide your budget across the four goals',
      objectives2a: 'Would you like to support something that does not fit within these categories? Then write it at the bottom under “Other, namely…” and allocate part of your budget to it.',
      objectives3: 'Could you briefly explain how you made your distribution? Why did you choose to divide it this way?',
      biodiversity_title: 'Biodiversity conservation',
      biodiversity_text: 'A rich biodiversity supports ecosystem functioning and is crucial for supporting all life on earth. Biodiversity conservation projects aim to enhance or conserve biodiversity values, often in a local context. Such projects can aim to improve soil and water quality or for instance the placement of nest boxes for birds.',
      ALC_title: 'Landscape quality and view',
      ALC_text: 'Landscape scenery relates to the view and enjoyment of a landscape.  A landscape scenery project can be about protecting or restoring landscape elements like hedge rows, rewilding the landscape or creating hiking routes or biking lanes across the landscape.',
      SUSBUS_title: 'Sustainable entrepreneurship',
      SUSBUS_text: 'Sustainable businesses engage in their economic activities without generating negative effects for their (local) environment. Sustainable business projects might relate to the transitioning of a conventional farm to organic or nature friendly farming. It can also refer to the creation of a network of local firms and organizations that reduce waste and pollution in an integrated manner.',
      finalize1: '<b>Thank you!</b><br> Thank you for participating in this study on nature financing by the University of Groningen. Your answers are valuable. Click <b>Save</b> to record your responses.',
      finalize1A: '<b>Hooray!</b><br> You have earned €10 for nature projects on Texel. Thank you — your contribution helps us understand how people want to support nature.',
      finalize1B: '<b>What happens next?</b><br> You will now go to the Greenmapper Friends community ‘National Park Dunes of Texel’ for part 3. There, you will review six real funding requests. For each project, indicate whether you support it and explain why.\n' + 'Your own contribution in this experiment is fictitious, but the €10 and €5 donations made on your behalf are real.',
      finalize1C: '<b>Extra reward for Texel</b><br> If you respond to all six requests, Greenmapper will donate an additional €5. Every response counts! After responding to all six requests, you will automatically be entered into the prize draw.',
      finalize2: 'Please be reminded that it is possible to retract your submitted data without any consequences. If you wish to do so, or have any other questions regarding the research, please send an e-mail to',
      cultural_title: 'Culture and community life',
      cultural_text: 'Natural areas may also have a cultural heritage or other cultural aspects included within them. For instance if they contain historical  buildings or monuments or if certain cultural events are related to them. Cultural projects relate to the organisation of (musical) events, educational trips or the conservation of landed estates.',
      other_title: 'Other',
      other_text: 'Would you like to fund something else in your favourite natural area, but this was not mentioned above? Please name it yourself! You can use this slider to indicate how much of your budget you would allocate to it. This is not required, only if you think of something that does not belong to the previous categories of funding objectives.',
      placeholder: 'Other namely..'
    }
  },
  drawer: {
    area_section: 'Discover',
    my_section: 'My overview',
    other_section: 'Other',
    edit_funding: 'My Nature Budget',
    per_year: '/year',
    messages: 'Messages'
  },
  mail: {
    to: 'To',
    none: 'No messages yet',
    from: 'From',
    subject: 'Title',
    date: 'Date',
    inbox: 'Inbox',
    outbox: 'Sent',
    compose: 'Compose'
  },
  gender: {
    male: 'Male',
    female: 'Female',
    other: 'Other'
  },
  education: {
    1: 'Less than highschool',
    2: 'High school graduate',
    3: 'Some college,no degree',
    4: 'Associate\'s degree',
    5: 'Bachelors degree',
    6: 'Master\'s degree',
    7: 'Professional school degree',
    8: 'Doctorate degree'
  },
  video: {
    'draw_popup_title_1': 'Neighborhood',
    'draw_popup_subtitle_1': 'Within 2km of home',
    'draw_popup_text_1': 'This map shows an area of 2km around your place of residence. Mark a nature-related spot within this 2km that is attractive, valuable, or important to you. If you do not know of a spot within the 2km circle, please mark an area as close to it as possible.',
    'draw_popup_title_2': 'Region',
    'draw_popup_subtitle_2': 'Within 20km of home',
    'draw_popup_text_2': 'This map shows an area of 20km around your place of residence. Mark a nature-related spot within this 20km that is attractive, valuable, and important to you.',
    'draw_popup_title_3': 'Country',
    'draw_popup_subtitle_3': 'Entire country',
    'draw_popup_text_3': 'This map shows a map of the Netherlands. Mark nature-related a spot on this map that is attractive, valuable, or important to you.',
    'draw_popup_title_4': 'World',
    'draw_popup_subtitle_4': 'Worldwide',
    'draw_popup_text_4': 'This map shows a map of the world. Mark a nature-related spot on this map that is attractive, valuable, or important to you.',
    'draw_popup_video': 'Below is a short video (30s) on how to draw an area.',
    'area_size': 'Area is {width} km wide with a surface of {area} km{squared}',
    'step1_helper': 'Drag the map so your attractive place sits fully inside the clear circle. Zoom until the circle covers it completely.',
    'step2_helper': 'Looks good? Continue — or optionally drag the points so the shape covers your place more accurately.',
    'clamp_hint_default': 'This stays within {distance}. The next question lets you go further.',
    'scale_badge_radius': 'Within {distance} of home',
    'scale_badge_full': 'On the map of {name}',
    'level_up_toast': 'Area enlarged to {distance}'
  }
};